/**
 * MobX store classes instantiation.
 * This is where all MobX stores are instantiated
 * and exported for use within the Provider.
 */
import { configurePersistable } from "mobx-persist-store";
import React from "react";
import { configure } from "mobx";
import UserStore from "./UserStore";
import BusinessStore from "./BusinessStore";
import WalletStore from "./WalletStore";
import BillsStore from "./BillsStore";
import SupportStore from "./SupportStore";
import CustomerStore from "./CustomerStore";
import EmployeeStore from "./EmployeeStore";
import PayrollStore from "./PayrollStore";
import TransactionStore from "./TransactionStore";
import InvoiceStore from "./InvoiceStore";
import AppStore from "./AppStore";
import InventoryStore from "./InventoryStore";
import ExchangeStore from "./ExchangeStore";
import PaymentLinkStore from "./PaymentLinkStore";
import BulkSmsStore from "./BulkSmsStore";
import QuotationStore from "./QuotationStore";
import AdminStore from "./AdminStore";
import BusinessCategoryStore from "./BusinessCategoryStore";
import ExpenseCategoryStore from "./ExpenseCategoryStore";
import SubscriptionStore from "./SubscriptionStore";
import AuditStore from "./AuditStore";
import ChargeStore from "./ChargeStore";
import FeedbackStore from "./FeedbackStore";
import SplitpaymentStore from "./SplitpaymentStore ";
import FashCreativeStore from "./FashCreativeStore";
import MarketersStore from "./MarketersStore";

/**
 * Configuration to ensure all state changes occur via MobX actions
 */

configure({ enforceActions: "observed" });
configurePersistable(
  {
    storage: window.localStorage,
    expireIn: 86400000,
    removeOnExpiration: true,
    stringify: true,
    debugMode: false,
  },
  { delay: 200, fireImmediately: false }
);

export const appStore = new AppStore();

export const userStore = new UserStore();

export const businessStore = new BusinessStore();

export const walletStore = new WalletStore();

export const billsStore = new BillsStore();

export const supportStore = new SupportStore();

export const customerStore = new CustomerStore();

export const transactionStore = new TransactionStore();
export const invoiceStore = new InvoiceStore();
export const employeeStore = new EmployeeStore();
export const payrollStore = new PayrollStore();
export const inventoryStore = new InventoryStore();
export const exchangeStore = new ExchangeStore();
export const paymentLinkStore = new PaymentLinkStore();
export const bulkSmsStore = new BulkSmsStore();
export const quotationStore = new QuotationStore();
export const adminStore = new AdminStore();
export const auditStore = new AuditStore();
export const businessCategoryStore = new BusinessCategoryStore();
export const expenseCategoryStore = new ExpenseCategoryStore();
export const subscriptionStore = new SubscriptionStore();
export const chargeStore = new ChargeStore();
export const feedbackStore = new FeedbackStore();
export const splitpaymentStore = new SplitpaymentStore();
export const fashCreativeStore = new FashCreativeStore();
export const marketersStore = new MarketersStore();

export const storesContext = React.createContext({
  userStore,
  businessStore,
  walletStore,
  billsStore,
  appStore,
  customerStore,
  employeeStore,
  payrollStore,
  supportStore,
  transactionStore,
  invoiceStore,
  inventoryStore,
  exchangeStore,
  paymentLinkStore,
  bulkSmsStore,
  quotationStore,
  adminStore,
  businessCategoryStore,
  expenseCategoryStore,
  subscriptionStore,
  auditStore,
  chargeStore,
  feedbackStore,
  splitpaymentStore,
  fashCreativeStore,
  marketersStore,
});

export const useStores = () => React.useContext(storesContext);
